module.exports = __webpack_public_path__ + "static/media/php.12c15f06.svg";